import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import Affiliate from '../../../Api/Models/Affiliate';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Search from '../../elements/Search';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import useAutoPaginator from '../../hooks/useAutoPaginator';

import { PERMISSION } from 'crm/helpers/Permissions';
import useAffiliateRevenueAuth from 'crm/hooks/useAffiliateRevenueAuth';

function AffiliatesList({ cardTitle, affiliateOwnerId }: Readonly<{ cardTitle?: string; affiliateOwnerId?: number }>) {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<Affiliate>(async (page, params) => {
        if (affiliateOwnerId > 0) {
            return CRMApi.affiliateOwners.getAffiliatesAssignedToAffiliateOwner(affiliateOwnerId, page, { params });
        }

        return CRMApi.affiliates.getAll(page, { params });
    });
    const hasAffiliateRevenueAccess = useAffiliateRevenueAuth();

    function getLinks(affiliate: Affiliate) {
        return (
            <>
                <ViewButton url={`/affiliates/${affiliate.id}`} permissions={[PERMISSION.VIEW_AFFILIATE]} />
                {affiliate.doesntHaveAdmin() && hasAffiliateRevenueAccess && (
                    <EditButton url={`/affiliates/${affiliate.id}/edit`} permissions={[PERMISSION.UPDATE_AFFILIATE]} />
                )}
                {affiliate.doesntHaveRegistrations() && (
                    <DeleteButton
                        url={`/crea/api/affiliate/${affiliate.id}`}
                        action={updateItems}
                        permissions={[PERMISSION.DELETE_AFFILIATE]}
                    />
                )}
            </>
        );
    }

    return (
        <Card title={cardTitle ?? 'All affiliates'}>
            <Search {...auto.search} />
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <th>ID</th>
                        <th>Name</th>
                        <th>Token</th>
                        <th>Register count</th>
                        <th>Sub register count</th>
                    </TableHead>
                    <tbody>
                        {items.map((affiliate) => (
                            <tr key={affiliate.id}>
                                <td>{getLinks(affiliate)}</td>
                                <td>{affiliate.id}</td>
                                <td>{affiliate.name}</td>
                                <td>{affiliate.token}</td>
                                <td>{affiliate.registerCount}</td>
                                <td>{affiliate.subRegisterCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default AffiliatesList;
